import { Injectable } from "@angular/core";
import { PatientService } from "./patient.service";
import {
  NotificationToastService,
  NotificationToastResponse,
} from "./notification-toast.service";
import { PatientReservationsDialogComponent } from "../components/dialogs/patient-reservations-dialog/patient-reservations-dialog.component";
import { MatDialog } from "@angular/material";

@Injectable({
  providedIn: "root",
})
export class PatientReservationMessageService {
  notificationToastResponse: NotificationToastResponse;

  constructor(
    private patientService: PatientService,
    private dialog: MatDialog,
    private notificationToastService: NotificationToastService
  ) {}

  showReservationAlertIfRequired(
    patientId: number,
    showPreAdmissionPatientAppointment: boolean = false,
    datesAfter: number = 0,
    datesBefore: number = 0
  ) {
    this.patientService
      .getReservationSearchItems(patientId,showPreAdmissionPatientAppointment, datesAfter, datesBefore)
      .then((reservations) => {
        if (reservations.length > 0) {
          if (this.notificationToastResponse) {
            this.notificationToastService.clear(
              this.notificationToastResponse.toastId
            );
          }

          this.notificationToastResponse = this.notificationToastService.info(
            `El paciente tiene ${reservations.length}
           turnos reservados. Ver detalle...`,
            "Paciente",
            true
          );
          this.notificationToastResponse.onTap.subscribe(() => {
            this.dialog.open(PatientReservationsDialogComponent, {
              width: "50%",
              data: reservations,
            });
          });
        }
      });
  }
}
